import React, { Suspense, lazy } from 'react';
import { Routes as Switch, Route, BrowserRouter, Navigate } from 'react-router-dom';
// import Loader from '../components/Loader';
import env from '../config/env';
import ContactUs from '../pages/ContactUs';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsOfService from '../pages/TermsOfService';

// Lazy load the components
const LandingPage = lazy(() => import('../pages/LandingPage'));
const Dashboard = lazy(() => import('../pages/Dashboard'));
const ForgotPassword = lazy(() => import('../pages/ForgetPassword'));
const Hotels = lazy(() => import('../pages/Hotels'));
const Invites = lazy(() => import('../pages/Invites'));
const Login = lazy(() => import('../pages/Login'));
const Menu = lazy(() => import('../pages/Menu'));
const NotFound = lazy(() => import('../pages/NotFound'));
const OrderPlacement = lazy(() => import('../pages/OrderPlacement'));
const Orders = lazy(() => import('../pages/Orders'));
const Inventory = lazy(() => import('../pages/Inventory'));
const ResetPassword = lazy(() => import('../pages/ResetPassword'));
const Settings = lazy(() => import('../pages/Settings'));
const Signup = lazy(() => import('../pages/Signup'));
const Staff = lazy(() => import('../pages/Staffs'));
const Tables = lazy(() => import('../pages/Tables'));
const VerifyUser = lazy(() => import('../pages/VerifyUser'));
const FoodCourtShopGateway = lazy(() => import('../pages/FoodCourtShopGateway'));
const AuthRoutes = lazy(() => import('./AuthRoutes'));
const PublicRoutes = lazy(() => import('./PublicRoutes'));

export default function Routes() {
    const hostname = location.hostname;
    const parts = hostname.split('.');

    const subdomain = parts.length >= 2 ? String(parts[0]).toLowerCase() : null;
    const tenants = env.tenant;
    const tenantId = subdomain ? tenants[subdomain] : null;

    return (
        <BrowserRouter>
            <Suspense fallback={<></>}>
                <Switch>
                    <Route path="/" element={<PublicRoutes />}>
                        <Route path="" element={
                            !tenantId ? <LandingPage /> : <OrderPlacement tenantId={tenantId} />
                        } />
                        <Route path="login" element={<Login />} />
                        <Route path="signup" element={<Signup />} />
                        <Route path="forgot-password" element={<ForgotPassword />} />
                        <Route path="verify" element={<VerifyUser />} />
                        <Route path="reset" element={<ResetPassword />} />
                        <Route path="/:token" element={<OrderPlacement />} />

                        {/* static pages for whatsapp service & payment gateway */}
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route path="/contact-us" element={<ContactUs />} />
                    </Route>
                    <Route path="/" element={<AuthRoutes />}>
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="invites" element={<Invites />} />
                        <Route path="hotels" element={<Hotels />} />
                        <Route path="staff" element={<Staff />} />
                        <Route path="menu" element={<Menu />} />
                        <Route path="settings" element={<Settings />} />
                        <Route path="tables" element={<Tables />} />
                        <Route path="orders" element={<Orders />} />
                        <Route path="inventory" element={<Inventory />} />
                    </Route>
                    <Route path="gateway" element={<FoodCourtShopGateway />} />
                    <Route path="/404" element={<NotFound />} />
                    <Route path="*" element={<Navigate to="/404" />} />
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
}
